import { useState } from 'react';
import { styledCompiler } from '../../utils/markdown';

const useFormField = fieldProps => {
  const { onChange: onFieldChange, field, value: fieldValue, isValid, errors, fieldAction } = fieldProps;
  const { id, name } = field.valueField;
  const { title } = field?.model || {};
  const label = title && styledCompiler(title);
  const { enable } = fieldAction || {};
  const [value, setValue] = useState(fieldValue);
  const onChange = e => {
    let possibleValue = e;
    if (typeof possibleValue !== 'string') {
      possibleValue = e?.target?.value;
    }
    setValue(possibleValue);
    onFieldChange(name, possibleValue, isValid, errors);
  };
  return { value, onChange, field, id, name, isValid, enable, label };
};

export default useFormField;
